import { formatBytes } from "@saucer/core";
import type { UploadJob } from "../use-uploads.js";

export function UploadList({
  jobs,
  onDismiss,
}: {
  jobs: UploadJob[];
  onDismiss: (id: string) => void;
}) {
  if (jobs.length === 0) return null;

  return (
    <ul className="uploads">
      {jobs.map((job) => (
        <li key={job.id} className="uploads__row">
          <span className="uploads__name mono">{job.filename}</span>
          <span className="meta">
            {job.status === "failed"
              ? job.error
              : `${formatBytes(job.uploaded)} of ${formatBytes(job.size)}`}
          </span>
          <progress
            className="uploads__bar"
            max={job.size || 1}
            value={job.status === "done" ? job.size || 1 : job.uploaded}
          />
          <button className="button button--quiet" type="button" onClick={() => onDismiss(job.id)}>
            {job.status === "uploading" ? "Hide" : "Clear"}
          </button>
        </li>
      ))}
    </ul>
  );
}
